<template>

  <div id="app" :class="{ 'off-canvas-menu-active': $store.state.off_canvas_menu_active }">


    <div id="header" v-if="false">
      <div id="header-bg"></div>
      <div class="corset">
      </div>
    </div>

    <div id="fixedcorset">

      <transition name="fade1" mode="out-in">
        <router-link :to="scooplogolinkdestination" id="header-logo" v-if="show_header_logo_scoopmodels">
          <svgicon icon="scoop_models_logo" />
          <span class="text-pre" v-if="$store.state.logo_pre_html" v-html="$store.state.logo_pre_html"></span>
        </router-link>
      </transition>

      <transition name="fade1" mode="out-in">
        <router-link to="/" id="header-logo" v-if="show_header_logo_scoopsocial">
          <svgicon icon="scoop_social_logo" />
        </router-link>
      </transition>

      <div id="header-am" v-if="is_site_am">
      
        <router-link to="/" id="header-logo-am">
          <span class="text">A Management</span>
          <svgicon icon="am_header_logo_large" />      
        </router-link>

        <div id="menubtn-am" @click="toggleOffCanvasMenuActive()">
          <span class="open"><svgicon icon="am_header_menubtn" /></span>
          <span class="close"><svgicon icon="am_header_menubtn_close" /></span>
        </div>

        <div id="menubtn-am-burger" @click="toggleOffCanvasMenuActive()">
          <div></div>
          <div></div>
          <div></div>
        </div>

        <router-link to="/" id="header-logo-am-small">
          <svgicon icon="am_small_logo" />      
        </router-link>
      
      </div>     
      
    </div>

    

    
    <template v-if="!is_site_am">
        <div id="offmenu-dim" @click="toggleOffCanvasMenuActive(0)"></div>
        <div id="offmenu">
          <left-menu baseclass="mobilemenu" />
        </div>
    </template>


    <template v-if="is_site_am">      
      <am-header-menu />
      <div id="offmenu-am-dim" @click="toggleOffCanvasMenuActive(false)"></div>
    </template>

    <template v-if="!is_site_am">
      <div id="menubtn" v-if="app_ready" @click="toggleOffCanvasMenuActive()"><div></div><div></div><div></div><div></div><div></div></div>
    </template>



    <div id="main-content">

      <div class="corset">
      
        <left-menu v-if="leftmenu_is == 'global'" />
        <left-menu-artist v-if="leftmenu_is == 'artist'" />
        <left-menu-influencer v-if="leftmenu_is == 'influencer'" />
        <left-menu-newsarticle v-if="leftmenu_is == 'newsarticle'" />              
      

        <template v-if="app_ready">
          
		        <transition
              v-on:before-enter="viewTransition_beforeEnter"
              v-on:enter="viewTransition_enter"
              v-on:leave="viewTransition_leave"
              duration="1000"
              v-bind:css="false"
              mode="out-in"
            >
            
              <router-view/>
            </transition>

        </template>
      
      </div>

    </div>
    

    <modal id="modal-finder" v-if="$store.state.findbox.open" dimmer-close btn-close @close="findbox_close()">
      <findbox />
    </modal>

    <modal id="modal-admin-media-lib" v-if="$store.state.modal.media_lib.open" dimmer-close btn-close @close="modal_close('media_lib')">
      <admin-media-lib />
    </modal>

    <modal id="modal-admin-media-info" v-if="$store.state.modal.media_info.open" dimmer-close btn-close @close="modal_close('media_info')">
      <admin-media-info />
    </modal>

    <modal id="modal-admin-media-preview" v-if="$store.state.modal.media_preview.open" dimmer-close btn-close @close="modal_close('media_preview')">
      <admin-media-preview />
    </modal>

    <modal id="modal-admin-media-crop" v-if="$store.state.modal.media_crop.open" dimmer-close btn-close @close="modal_close('media_crop')">
      <admin-media-crop />
    </modal>

    <modal id="modal-admin-media-tweak" v-if="$store.state.modal.media_tweak.open" dimmer-close btn-close @close="modal_close('media_tweak')">
      <admin-media-tweak />
    </modal>

    <modal id="modal-admin-media-upload" v-if="$store.state.modal.media_upload.open" :dimmer-close="false" :btn-close="false" @close="modal_close('media_upload')">
      <admin-media-upload />
    </modal>

    <modal id="modal-admin-media-upload-video" v-if="$store.state.modal.media_upload_video.open" dimmer-close btn-close @close="modal_close('media_upload_video')">
      <admin-media-upload-video />
    </modal>

    <modal id="modal-model-book-thumb" v-if="$store.state.modal.model_book_thumb.open" dimmer-close btn-close @close="modal_close('model_book_thumb')">
      <admin-model-book-thumb />
    </modal>

    <modal id="modal-video-player" v-if="$store.state.modal.video_player.open" dimmer-close btn-close @close="modal_close('video_player')">
      <video-player />
    </modal>

    <modal id="modal-model-options" v-if="$store.state.modal.media_edit_links.open" dimmer-close btn-close @close="modal_close('media_edit_links')">
      <admin-media-links-modal />
    </modal>

    <modal id="modal-am-add-casting-by-artist" v-if="$store.state.modal.am_add_casting_by_artist.open" dimmer-close btn-close @close="modal_close('am_add_casting_by_artist')">
      <am-add-casting-by-artist />
    </modal>


    <modal id="modal-admin-media-edit-links" v-if="$store.state.modal.model_options.open && $store.state.loaded_model" dimmer-close btn-close @close="modal_close('model_options')">
      <a class="btn btn-white shadowed btn-full" target="_blank" :href="base_url+'pdf/model_setcard/'+$store.state.loaded_model.slug">Download setcard</a>
      <a class="btn btn-white shadowed btn-full" target="_blank" :href="base_url+'pdf/model_polaroids/'+$store.state.loaded_model.slug">Download polaroids</a>
      <a class="btn btn-white shadowed btn-full" v-if="false" target="_blank" :href="base_url+'download_full_book/model/'+$store.state.loaded_model.slug">Download full book</a>
      <div class="btn btn-white shadowed btn-full" @click="fullBookPassGate()">Download full book</div>
    </modal>


    <modal v-if="false" dimmer-close btn-close @close="msg(22)">
      <p>Other modal</p>
    </modal>


    <modal id="generic-field-editor" v-if="$store.state.generic_field_editor.active" dimmer-close @close="set_generic_field_editor({active:false})">
      <generic-field-editor />      
    </modal>


    <transition name="fade1" mode="out-in">
      <div id="popup-added-to-casting" v-if="show_added_to_casting_modal">
        Added to package &mdash; 
        <router-link to="/package">Go to your package</router-link>
      </div>
    </transition>


    
    <div id="admin-minimenu" v-if="loggedin_user" :class="{active:admin_minimenu_open}" @mouseleave="adminminimenu_leaveclose()">
      <div class="b" @click="toggleAdminMiniMenu()">Hi, {{loggedin_user.first_name}}</div>
      <div class="m">
        
        <router-link v-if="admin_minimenu.adminhome" :to="'/admin'" class="mbtn" @click.native="toggleAdminMiniMenu(false)">Admin home</router-link>
        <router-link v-if="admin_minimenu.edit_newsarticle" :to="'/admin/page/'+loaded_page_id" class="mbtn" @click.native="toggleAdminMiniMenu(false)">Edit newsarticle</router-link>      
        <router-link v-if="admin_minimenu.edit_artistgallery" :to="'/admin/page/'+loaded_page_id" class="mbtn" @click.native="toggleAdminMiniMenu(false)">Edit gallery</router-link>
        <router-link v-if="admin_minimenu.edit_page" :to="'/admin/page/'+loaded_page_id" class="mbtn" @click.native="toggleAdminMiniMenu(false)">Edit page</router-link>      
        <router-link v-if="admin_minimenu.edit_model" :to="'/admin/model/'+$store.state.loaded_model.id" class="mbtn" @click.native="toggleAdminMiniMenu(false)">Edit {{$store.state.loaded_model.first_name}}</router-link>
        <router-link v-if="admin_minimenu.edit_artist" :to="'/admin/artist/'+$store.state.loaded_artist.id" class="mbtn" @click.native="toggleAdminMiniMenu(false)">Edit {{$store.state.loaded_artist.first_name}}</router-link>
        <router-link v-if="admin_minimenu.edit_influencer" :to="'/admin/influencer/'+$store.state.loaded_influencer.id" class="mbtn" @click.native="toggleAdminMiniMenu(false)">Edit {{$store.state.loaded_influencer.first_name}}</router-link>                
        <div v-if="admin_minimenu.edit_blocklayouter" @click="adminminimenu_editLayout()" class="mbtn">Edit layout</div>
        <div v-if="admin_minimenu.exit_blocklayouter" @click="adminminimenu_editLayout_blockEditor_exit()" class="mbtn">Exit layout-editor</div>        
        <div v-if="false && admin_minimenu.save_blocklayouter " @click="adminminimenu_editLayout_blockEditor_save()" class="mbtn">Save layout</div>
        <div v-if="admin_minimenu.logoutbtn" @click="doLogOut()" class="mbtn">Log out</div>
      </div>
    </div>



    <div id="cookie-warning" class="hide">
			<div class="corset">
				<p>We use cookies to enhance your browsing experience.<a id="cookies-ok" href="#ok" @click="cookiesOkClick()">Ok</a></p>
			</div>
		</div>



    <router-link class="package-minimenu" to="/package" v-if="route.name != 'page-casting' && route.name != 'page-catalog' && $store.getters.active_casting && $store.getters.active_casting.items.length">
      <span class="text1">Go to your package</span>
      <span class="text2">Added to package</span>
    </router-link>


    <template v-if="!app_ready">
      <div id="small-spinner"></div>
      <div id="app_loadbar"><div id="fill" :style="{'width': firebase_load_pct+'%' }"></div></div>
      <div id="loadingtextman">{{loadingtextman_text}}</div>
    </template>

    <div id="small-spinner" v-if="$store.state.small_spinner"><div class="spinner"></div></div>
    <div id="big-spinner" v-if="$store.state.big_spinner"><div class="spinner"></div></div>

    <div id="icon-signal" v-if="iconSignal">
      <svgicon v-if="iconSignal=='heart'" icon="ionicons/android-favorite-outline"></svgicon>
      <svgicon v-if="iconSignal=='check'" icon="ionicons/checkmark"></svgicon>
      <svgicon v-if="iconSignal=='thumbsup'" icon="linearicons/thumbs-up"></svgicon>
    </div>

    <template v-for="msg in $store.state.msgs">
      <div class="msg-modal">
        <div class="msg-dimmer" @click="kill_msg()"></div>
        <div class="msg-popup"><div class="overflower" v-html="msg.text"></div></div>
      </div>
    </template>

  

    <div id="ambetagate" v-if="false && is_site_am && !loggedin_user && $route.name != 'page-login'">
      <img src="/assets/img/am_large_logo.svg" alt="" />
      <br><br>
      <a href="mailto:gitte@scoopmodels.com">Contact</a>
    </div>
    

  </div>
</template>
<script>
  
  import helpers from './helpers.js'
  import { throttle } from 'throttle-debounce'

  import mixins from './mixins.js';
  import store from './store/store.js';
  
  import Box from './components/Box'
  import Btn from './components/Btn'
  import Modal from './components/Modal'

  import findbox from './views/findbox'
  import GenericFieldEditor from './views/GenericFieldEditor'
  
  import VideoPlayer from './views/VideoPlayer'

  import LeftMenu from './views/LeftMenu'
  import LeftMenuArtist from './views/LeftMenuArtist'
  import LeftMenuInfluencer from './views/LeftMenuInfluencer'
  import LeftMenuNewsarticle from './views/LeftMenuNewsarticle'

  import AmHeaderMenu from './views/amanagement/AmHeaderMenu'
  import AmAddCastingByArtist from './views/amanagement/AmAddCastingByArtist'

  //import Leftnavbar from './views/Leftnavbar'
  //import MediaLib from './components/MediaLib'
  //import ImageEditor from './views/ImageEditor'
  
  import './components/generated_svg_icons/ionicons/android-favorite-outline'
  import './components/generated_svg_icons/ionicons/checkmark'
  import './components/generated_svg_icons/linearicons/thumbs-up'
  import './components/generated_svg_icons/scoop_models_logo'
  import './components/generated_svg_icons/scoop_social_logo'

  import './components/generated_svg_icons/am_header_logo_large'
  import './components/generated_svg_icons/am_header_menubtn'
  import './components/generated_svg_icons/am_header_menubtn_close'
  import './components/generated_svg_icons/am_small_logo'


	export default {
    name: 'app',
    mixins: [ mixins.generic ],
    components: { 
      //Leftnavbar, 
      Box, Btn, Modal,    
      LeftMenu, LeftMenuArtist, LeftMenuInfluencer, LeftMenuNewsarticle,
      findbox,
      AmHeaderMenu, AmAddCastingByArtist, 
      VideoPlayer, GenericFieldEditor,
      
      'AdminMediaLib': () => import('./views/admin/media/AdminMediaLib'), // async lazyloaded chunked component
      'AdminMediaInfo': () => import('./views/admin/media/AdminMediaInfo'), // async lazyloaded chunked component
      'AdminMediaPreview': () => import('./views/admin/media/AdminMediaPreview'), // async lazyloaded chunked component
      'AdminMediaCrop': () => import('./views/admin/media/AdminMediaCrop'), // async lazyloaded chunked component
      'AdminMediaTweak': () => import('./views/admin/media/AdminMediaTweak'), // async lazyloaded chunked component
      'AdminMediaUpload': () => import('./views/admin/media/AdminMediaUpload'), // async lazyloaded chunked component
      'AdminMediaUploadVideo': () => import('./views/admin/media/AdminMediaUploadVideo'), // async lazyloaded chunked component
      'AdminModelBookThumb': () => import('./views/admin/AdminModelBookThumb'), // async lazyloaded chunked component
      'AdminMediaLinksModal': () => import('./views/admin/media/AdminMediaLinksModal'), // async lazyloaded chunked component

    },
	  data() {
	    return {
        iconSignal: undefined,
        app_ready: false,

        show_added_to_casting_modal: false,

        admin_minimenu_open: false,

	    }
	  },
    computed: {

      //user(){ return this.$store.getters['users/my_user'] },

      show_header_logo_scoopmodels(){
        if( this.is_site_am ) return false
        if( this.is_site_scoopsocial ) return false
        //if( this.$route.name == 'frontpage' ) return false
        return true
      },

      show_header_logo_scoopsocial(){
        if( this.is_site_am ) return false
        if( !this.is_site_scoopsocial ) return false
        if( this.$route.name == 'frontpage' ) return false
        return true
      },

      scooplogolinkdestination(){
        if( this.$route.name == 'frontpage' ) return '/news'
        return '/'
      },
      
      
      
      leftmenu_is(){

        var rt = this.route_tags

        //if( this.is_fetching_content ) return false
        
        if( this.is_site_am ) return false

        if ( rt.page ) {
          var loaded_page = this.$store.state.loaded_page
          if( loaded_page && loaded_page.category == 'newsarticle' ) return 'newsarticle'
          if( loaded_page && loaded_page.category == 'artistgallery' ) return 'artistgallery'
        }

        if( rt.model_single ) return 'model'
        if( rt.influencer_single ) return 'influencer'

        if( rt.leftmenu ) return rt.leftmenu

        return 'global'

      },


      admin_minimenu(){
        var m = {
          adminhome: true,
          edit_model: false,
          edit_artist: false,
          edit_influencer: false,
          edit_page: false,
          edit_newsarticle: false,
          logoutbtn: true,
          edit_blocklayouter:  false,
          save_blocklayouter:  false,
          exit_blocklayouter:  false,
        }

        if( this.editable_layoutblocks ) m.edit_blocklayouter = true
        if( this.editing_blocks ) m.save_blocklayouter = true
        if( this.editing_blocks ) m.exit_blocklayouter = true

        if( this.editing_blocks ) m.logoutbtn = false

        if( !this.loggedin_user ) return m

        var rt = this.route_tags
        
        if( rt.model_single && this.$store.state.loaded_model ) m.edit_model = true
       
        if( rt.artist_single && this.$store.state.loaded_artist ) m.edit_artist = true

        if( rt.influencer_single && this.$store.state.loaded_influencer  ) m.edit_influencer = true
        
        if( rt.page && this.$store.state.loaded_page  ) {
          if( this.$store.state.loaded_page.category && this.$store.state.loaded_page.category == 'newsarticle' ) m.edit_newsarticle = true        
          if( this.$store.state.loaded_page.category && this.$store.state.loaded_page.category == 'artistgallery' ) m.edit_artistgallery = true        
          if( !this.$store.state.loaded_page.category || this.$store.state.loaded_page.category == 'static' ) m.edit_page = true
        }                      

        if( this.editing_blocks ) m.adminhome = false
        if( this.editing_blocks ) m.edit_model = false
        if( this.editing_blocks ) m.edit_artist = false
        if( this.editing_blocks ) m.edit_influencer = false
        if( this.editing_blocks ) m.edit_page = false
        if( this.editing_blocks ) m.edit_newsarticle = false
        if( this.editing_blocks ) m.edit_artistgallery = false

        return m
      },

    },
	  methods: {

//--------------------------------------------------------------------------------          

      msg(input){
        alert(input)
      },

      toast(input) {
        
        if( typeof input === 'string' ) input = { text:input }
        
        if( typeof input === 'object' && input.length !== undefined ) {
          if( input.length === 1 ) input = { text:input[0] }
          if( input.length === 2 ) input = { text:input[0], position:input[1] }
          if( input.length === 3 ) input = { text:input[0], position:input[1], type:input[2] }
        }

        if( !input.position ) input.position = 'bottom-right'
        if( !input.duration ) input.duration = '4000'
        this.$toasted.show(input.text, input)
      },
      
      toggleOffCanvasMenuActive(bool){
        if( bool == undefined ) bool = !this.$store.state.off_canvas_menu_active
        this.$store.commit('set_off_canvas_menu_active', bool )        
      },      


      triggerIconSignal(icon){
        this.iconSignal = icon
        var _this = this
        setTimeout(function(){
          _this.iconSignal = false
        }, 1300)
      },
      
//--------------------------------------------------------------------------------          

      log( input ){
        return
        if( window.env == 'live' ) return

        if( typeof input != 'object' ) {
          console.log('%c  Kia  %c  '+input+'  ', 'background: #333; color: #fff; border-radius: 4px 0 0 4px;', 'background: #DDD; color: #000; border-radius: 0 4px 4px 0;')
          //console.log( '%c >> App log: '+input, 'color: #00883F;' )
        }
        
        if( typeof input == 'object' ) {
          console.log(input)
        }

      },

//--------------------------------------------------------------------------------    

      checkLocalStoredLoginData(){

        var data = localStorage.getItem('scoop_loggedin_user')
        if( !data ) return
        data = JSON.parse(data)
        if( !data ) return
        if( !data.id ) return

        this.$store.commit('set_loggedin_user', data)
        //console.log('user was logged in')

      },

//--------------------------------------------------------------------------------    

      viewTransition_beforeEnter(){},
      viewTransition_enter(){},
      viewTransition_leave(){
        //console.log('viewTransition_leave')
      },

//--------------------------------------------------------------------------------    

      toggleAdminMiniMenu(boolean){
        if( boolean == undefined ) boolean = !this.admin_minimenu_open
        this.admin_minimenu_open = boolean
      },

//--------------------------------------------------------------------------------    

      adminminimenu_editLayout(){
        //this.toggleAdminMiniMenu(false)
        this.editLayout()
      },

//--------------------------------------------------------------------------------    

      adminminimenu_leaveclose(){

        var _this = this

        setTimeout(() => {

          //if( _this.$refs.adminminimenu.classList.contains('active') ) _this.$refs.adminminimenu.classList.remove('active')

        }, 1500)

      },

//--------------------------------------------------------------------------------    

      adminminimenu_editLayout_blockEditor_exit(){ eventBus.$emit('blockEditor_exit') },
      adminminimenu_editLayout_blockEditor_save(){ eventBus.$emit('blockEditor_save') },

//--------------------------------------------------------------------------------    

      trackEvent(input) {
        var data = {}
    		if(input.cat != undefined) 		  data.category = input.cat
    		if(input.action != undefined) 	data.action = input.action
    		if(input.label != undefined) 	  data.label = input.label
    		if(input.value != undefined) 	  data.value = input.value
        
        //this.$gtm.trackEvent(data)
        //console.log(data)

        if( this.is_local ) {
          this.log('localdev mode > trackEvent > category: '+data.category +', action: '+ data.action +', label: '+ data.label +', value: '+ data.value)
          return
        }

        console.log('LIVE TrackView: '+location)
        console.log('ga object', this.$ga)
        console.log('ga object event method', this.$ga.event)
        //this.trackingSetupUserDimensions()
        //this.$ga.event( data.category, data.action, data.label, data.value )

  	  },

//--------------------------------------------------------------------------------    

      trackView(location) {
        
        if( this.is_local ) {        
          this.log('localdev mode > TrackView > '+location)
          return
        }

        

        if( globals.device.platform != 'ipad-cordova' ) return // only cordova trackings plz

        console.log('LIVE TrackView > '+location)
        console.log('ga obj', this.$ga)
        console.log('ga obj page method', this.$ga.page)
        //this.trackingSetupUserDimensions()
        //this.$ga.page( location )
      },

//--------------------------------------------------------------------------------    

      trackingSetupUserDimensions(){
        
        if( !this.$ga ) {
          console.log('trackingSetupUserDimensions >> GA object not found...')
          return
        }

        if( this.loggedin_user ) {
          this.$ga.set('userId', this.loggedin_user.email)
        }

        //this.$ua.injectGlobalDimension( 1, parseInt(this.loggedin_user.sap_id) )
        //this.$ua.injectGlobalDimension( 2, this.loggedin_user.email )

      },

//--------------------------------------------------------------------------------    

      doLogOut(){
        this.$store.dispatch('user_logout')
        this.$router.push('/news')
      },

//--------------------------------------------------------------------------------    

      setFavicon( url ){
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = url
        document.getElementsByTagName('head')[0].appendChild(link)        
      },

//--------------------------------------------------------------------------------    

      fullBookPassGate(){

          if( !this.loggedin_user && !helpers.passgate() ) return false

          this.modal_close('model_options')

          var url = this.base_url + '/download_full_book/model/' + this.$store.state.loaded_model.slug
          window.open(url)

      },

//--------------------------------------------------------------------------------    

      cookiesOkClick(){
        localStorage.setItem('cookieWarned',1)
        var el = document.querySelector('#cookie-warning')
        if( !el ) return
        el.classList.add('hide')
        this.trackEvent('site','Cookies-okay button click')
      },

//--------------------------------------------------------------------------------    

      active_casting_save_to_cloud(){

        var _this = this
        var casting = this.$store.state.castings[ this.$store.state.casting_active_index ]

        this.fetch( 'casting_save', { casting, skip_set_is_fetching_content:true, }, 
        { onSuccess: function(output){
          //console.log('CASTING -- SAVED')
        }, onError: function(output){
          //console.log('CASTING -- COULD NOT SAVE')
        }})        
      
      },
      
//--------------------------------------------------------------------------------    

	  },// methods
	  created(){

      var domain = window.location.hostname
      if( !domain || !domain.length ) alert('ERROR #57 - domain name could not be determined')
      this.$store.commit('set_domain', domain)

      //if( this.is_site_am ) this.setFavicon( 'static/favicon_am.ico' )

      this.checkLocalStoredLoginData()

      var _this = this
      eventBus.$on('toast', function (input) { _this.toast(input) })
      eventBus.$on('log', function (input) { _this.log(input) })
      eventBus.$on('triggerIconSignal', function (icon) { _this.triggerIconSignal(icon) })
      
      eventBus.$on('doLogOut', function (input) { _this.doLogOut(input) })

      eventBus.$on('set_show_added_to_casting_modal', function (boolean) { _this.show_added_to_casting_modal = boolean })
      
      eventBus.$on('active_casting_save_to_cloud', function() { _this.active_casting_save_to_cloud() })

      eventBus.$on('trackEvent', function (input) { _this.trackEvent(input) })
      eventBus.$on('trackView', function (location) { _this.trackView(location) })

      

      if( window.env = 'local' ) window.$store = _this.$store      

      _this.app_ready = true
      setTimeout(function(){
        _this.app_ready = true
      }, 200)

      
      document.addEventListener('scroll', throttle(300, (e) => {

        var scrolltop = document.documentElement.scrollTop

        var bodyScrolledFocus = ( scrolltop > 50 )
        document.body.classList.toggle('scrolled-focus', bodyScrolledFocus)

        var bodyScrolledFocusAm = ( scrolltop > 70 )
        document.body.classList.toggle('scrolled-focus-am', bodyScrolledFocusAm)
          
        if(_this.off_canvas_menu_active) _this.toggleOffCanvasMenuActive(0)

        //_this.toggleAdminMiniMenu(false)

      }))

      
      this.trackingSetupUserDimensions()

      this.$store.dispatch('settings_fetch')
      
    },// created

    mounted(){

      // show cookie warning?
      var cookieWarned = localStorage.getItem('cookieWarned')
      if( cookieWarned != 1 ) {
        var el = document.querySelector('#cookie-warning')
        if( el ) el.classList.remove('hide')
      }

      //if( this.loggedin_user ) this.$store.dispatch('get_my_castings',this.loggedin_user.email)

      if( this.is_local ) document.body.classList.add('localhosted')

    }, // mounted

	}


</script>

<style lang="scss">
  @import "./styling/main.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue